export default __webpack_public_path__ + "static/sam42_science-b61c0ae40d5efa1e11ce50b3dee51595.jpg";